import { get } from 'lodash-es';
import useRequestContext from './useRequestContext';

// this value comes from the backend and will only be updated upon refresh
export default function useAcceptedCookies(defaultValue = []) {
    const state = useRequestContext();

    return get(state, 'acceptedCookieCategories', defaultValue);
}
